

export class Admin_Dashboard_Upcomming_Holiday implements IAdmin_Dashboard_Upcomming_Holiday {
    fromDate!: Date;
    holidaydate!: string | undefined;
    holidayName!: string | undefined;
    holidayDateDayName!: string | undefined;

    constructor(data?: IAdmin_Dashboard_Upcomming_Holiday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.holidaydate = _data["holidaydate"];
            this.holidayName = _data["holidayName"];
            this.holidayDateDayName = _data["holidayDateDayName"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Upcomming_Holiday {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Upcomming_Holiday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["holidaydate"] = this.holidaydate;
        data["holidayName"] = this.holidayName;
        data["holidayDateDayName"] = this.holidayDateDayName;
        return data; 
    }
}

export interface IAdmin_Dashboard_Upcomming_Holiday {
    fromDate: Date;
    holidaydate: string | undefined;
    holidayName: string | undefined;
    holidayDateDayName: string | undefined;
}

